import _ from 'lodash';

import analytics from 'scripts/lib/analytics';
import { DomainError } from 'scripts/application/lib/error';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_interactive_handler';
import i18n from 'scripts/i18n/i18n';
import ShowToast from 'actions/toast_deprecated/show_toast';
import { ToastType } from 'models/toast_deprecated';

export default class EmailSharedSendersGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  onAddSuccess() {
    analytics.track('email shared sender - add success');
    this.context.executeAction(ShowToast, {
      type: ToastType.SUCCESS,
      message: i18n.t('Added to shared senders. New email from this address will start its own conversation.'),
    });
  }

  onAddError(err) {
    analytics.track('email shared sender - add error');

    // A rejected address is permanent, so say why instead of inviting a retry.
    if (err instanceof DomainError) {
      const detail = _.get(err, 'errors[0].detail');
      this.context.executeAction(ShowToast, {
        type: ToastType.ERROR,
        message: detail
          ? i18n.t('This address could not be added to shared senders: {{detail}}', { detail })
          : i18n.t('This address could not be added to shared senders.'),
      });

      return;
    }

    handleCommonErrors(this.context, err);
  }
}
